module.exports = __webpack_public_path__ + "static/media/restaurant-banner.2b2a7d7c.jpg";